import {
  layout_styles_default
} from "./chunk.533TB6KY.js";
import {
  HasSlotController
} from "./chunk.CLKP6Z3C.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  n
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/layout/layout.ts
var FadvLayoutSection = class extends HTMLElement {
  constructor() {
    super(...arguments);
    this.validSlots = ["left", "right", "top-outer", "top-inner"];
  }
  connectedCallback() {
    const slot = this.getAttribute("position");
    if (slot && this.validSlots.indexOf(slot) >= 0) {
      this.slot = slot;
    }
    this.classList.add("layout-section");
  }
};
FadvLayoutSection = __decorateClass([
  n("fadv-layout-section")
], FadvLayoutSection);
var FadvLayoutMain = class extends HTMLElement {
  connectedCallback() {
    this.slot = "layout-main";
  }
};
FadvLayoutMain = __decorateClass([
  n("fadv-layout-main")
], FadvLayoutMain);
var FadvLayout = class extends s {
  constructor() {
    super(...arguments);
    this.hasSlotController = new HasSlotController(this, "top-outer", "top-inner", "left", "right");
    this.fixed = false;
  }
  renderSlot(slotName) {
    return $`<slot name=${slotName}></slot>`;
  }
  render() {
    return $`<div class=${o({
      layout: true,
      "layout--fixed": this.fixed,
      "layout--has-top-outer": this.hasSlotController.test("top-outer"),
      "layout--has-top-inner": this.hasSlotController.test("top-inner"),
      "layout--has-left": this.hasSlotController.test("left"),
      "layout--has-right": this.hasSlotController.test("right")
    })} ><section part="top-outer" class="layout--above">${this.renderSlot("top-outer")}</section><div class="layout--content"><aside part="aside-left" class="layout--aside-left">${this.renderSlot("left")}</aside><div class="layout--center"><section part="top-inner" class="layout--top-inner">${this.renderSlot("top-inner")}</section><main part="base" class="layout--main">${this.renderSlot("layout-main")}</main></div><aside part="aside-right" class="layout--aside-right">${this.renderSlot("right")}</aside></div></div>`;
  }
};
FadvLayout.styles = layout_styles_default;
__decorateClass([
  e({ reflect: true, type: Boolean })
], FadvLayout.prototype, "fixed", 2);
FadvLayout = __decorateClass([
  n("fadv-layout")
], FadvLayout);

export {
  FadvLayoutSection,
  FadvLayoutMain,
  FadvLayout
};
